import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { AuthContext } from "../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useHistory } from 'react-router-dom';
import useVisinaTabele from "../../custom/visinaTabele";

const Servis = (props) => {
  const { t } = useTranslation();
  const { changeView } = props;

  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const history = useHistory();
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user);
  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData]);

  const getId = (row) => row?.Izaberi ?? row?.ID ?? row?.id ?? null;
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);

  const getDocumentLocation = (path) => {
    if (!path) return null;
    const normalizedPath = path.replace(/\\/g, '/');
    const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
    const encodedPath = encodeURI(relativePath);
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
  };

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const getConfigColumns = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({ id_config: 265 }),
    };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors);

    if (data.message) {
      toast.current.show({ severity: "error", summary: "Error", detail: data.message, life: 3000 });
      return { empty: true, data: [] };
    }

    return data.length > 0 ? { empty: false, data } : { empty: true, data: [] };
  };

  useEffect(() => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + `/service/returnAllDataService`, requestOptions)
      .then(handleErrors)
      .then(async (data) => {
        setTableData(data);

        if (data && data.length > 0) {
          const columns = Object.keys(data[0])
            .filter(key => !['ID', 'IDFaktura'].includes(key))
            .map(key => ({ label: key, value: key }));

          setAllColumns(columns);
          setOriginalColumnOrder(Object.keys(data[0]));

          const columnsDB = await getConfigColumns();
          if (!columnsDB.empty && columnsDB.data.length > 0) {
            setSelectedColumns(JSON.parse(columnsDB.data[0].parametri));
          } else {
            setSelectedColumns(columns.slice(0, 5).map(col => col.value));
          }
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
        });
      });
  }, [auth.token, company.companyId, refreshKey]);

  const handleIzaberiDialog = (rowData) => {
    const id = getId(rowData);
    setSelectedRowId(prev => String(prev) === String(id) ? null : String(id));

    confirmDialog({
      message: "Jel ste sigurni da želite nastaviti sa editovanjem servisnog naloga?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => {
        history.push({
          pathname: "/servis/unos_servisa",
          state: { selectedServiceLogId: id },
        });
      },
      reject: () => {},
    });
  };

  const handleStornoDialog = (rowData) => {
    const id = getId(rowData);
    if (rowData['IDFaktura']) {
      toast.current.show({
        severity: 'warn',
        summary: 'Upozorenje!',
        detail: 'Nije moguće stornirati servisni nalog jer je faktura vezana!',
        life: 4000
      });
      return;
    }
    confirmDialog({
      message: `Jel ste sigurni da želite stornirati servisni nalog #${id}?`,
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => handleStorno(id),
      reject: () => {},
    });
  };

  const handleStorno = async (id) => {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({ id }),
    };

    await fetch(process.env.REACT_APP_BACKEND_URL + "/service/DeleteServiceLog", requestOptions)
      .then(handleErrors)
      .then((data) => {
        toast.current.show({ severity: "success", summary: data.message, life: 3000 });
        setSelectedRowId(null);
        setRefreshKey(prev => prev + 1);
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
        });
      });
  };

  const previewBodyTemplate = (rowData, field) => {
    if (field === 'Izaberi' || field.startsWith('Izaberi')) {
      const selected = isSelected(rowData);
      return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center' }}>
          <Button
            label={t('nova.izaberi')}
            icon="pi pi-eye"
            className="p-button-text p-button-sm"
            onClick={() => handleIzaberiDialog(rowData)}
            tooltip="Izaberi servisni nalog za dalji rad"
            tooltipOptions={{ position: 'top' }}
          />
          {selected && (
            <Button
              label={t('nova.storno')}
              icon="pi pi-ban"
              className="p-button-text p-button-sm p-button-danger"
              onClick={() => handleStornoDialog(rowData)}
              tooltip="Stornirati servisni nalog"
              tooltipOptions={{ position: 'top' }}
            />
          )}
        </div>
      );
    }

    const filePathsString = rowData[field];
    if (!filePathsString) return '-';
    return filePathsString;
  };

  const isFileColumn = (field) => {
    return field.startsWith('Izaberi') ||
      field.includes('File') ||
      field.includes('fajl') ||
      field.includes('upload') ||
      field.endsWith('LK') ||
      field.endsWith('VD') ||
      field.endsWith('PASS') ||
      field.endsWith('VIZA') ||
      field.includes('Dokument');
  };

  const exportExcel = async () => {
    if (!selectedColumns || selectedColumns.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Servisni nalozi');
    const headers = selectedColumns;

    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFEFEF' } };
      cell.border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
    });

    tableData.forEach((rowData) => {
      const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
      row.eachCell((cell) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    });

    worksheet.columns.forEach((column, i) => {
      const lengths = [headers[i].length, ...tableData.map(row => (row[headers[i]] ?? "").toString().length)];
      column.width = Math.max(...lengths) + 2;
    });

    const date = new Date();
    const serbianDateTime = date.toLocaleString('sr-RS', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Belgrade'
    }).replace(/\s/g, ' ').replace(/,/g, '');

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      `Servisni nalozi - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };

  const header = (
    <div className="export-buttons fakture-stavke-header">
      <div className="fakture-stavke-radnje">
        <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
      </div>
    </div>
  );

  const handleSaveConfig = () => {
    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptInsertConfig,
      reject: rejectInsertConfig,
    });
  };

  const acceptInsertConfig = () => {
    if (selectedColumns.length > 0) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
        body: JSON.stringify({ id_config: 265, parametri: selectedColumns }),
      };

      fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
        .then(handleErrors)
        .then((data) => {
          if (data.message && data.message === 'Nema izmena u podacima konfiguracije pregleda.') {
            toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: data.message, life: 3000 });
            return;
          }
          toast.current.show({ severity: "success", summary: "Uspešna izmena konfiguracije pregleda za servise!", life: 3000 });
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
          });
        });
    } else {
      toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: "Morate imati barem 1 izabranu stavku!", life: 3000 });
    }
  };

  const rejectInsertConfig = () => {};

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <ConfirmDialog />
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
        <div style={{ width: "20%" }}>
          {allColumns.length > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MultiSelect
                value={selectedColumns}
                options={allColumns}
                onChange={(e) => {
                  const sorted = originalColumnOrder.filter(key => e.value.includes(key));
                  setSelectedColumns(sorted);
                }}
                optionLabel="label"
                display="chip"
                placeholder={t('nova.odaberiteKolone')}
                style={{ width: '100%' }}
                showSelectAll={true}
                filter
                filterPlaceholder="Pretraži kolone"
                maxSelectedLabels={3}
                selectedItemsLabel="{0} kolona odabrano"
              />
              <button onClick={handleSaveConfig} style={{ marginLeft: '1%' }} className="configSaveButton">
                <i className="pi pi-save"></i>
              </button>
            </div>
          )}
        </div>
        <div>
          <input
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder={t('nova.phPretraga')}
            className="p-inputtext p-component"
          />
        </div>
      </div>
      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable className="stavke-tabela"
        value={tableData}
        paginator
        rows={redovaTabele}
        header={header}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        loading={tableData === null}
        resizableColumns
        columnResizeMode="expand"
        rowClassName={(rowData) => isSelected(rowData) ? 'selected-row' : ''}
      >
        {selectedColumns.map((colKey) => {
          const colMeta = allColumns.find(col => col.value === colKey);
          return (
            <Column
              key={colKey}
              field={colKey}
              header={colMeta?.label || colKey}
              sortable
              body={(rowData) => {
                if (isFileColumn(colKey)) {
                  return previewBodyTemplate(rowData, colKey);
                }
                return rowData[colKey] || '-';
              }}
              style={{ minWidth: '150px' }}
            />
          );
        })}
      </DataTable>
      </div>
    </div>
  );
};

export default Servis;
